import { BASE_URL, NEXTJS_SERVER_BASE_URL } from "@/utils";
import getToken from "@/utils/getToken";
import axios, { AxiosRequestConfig } from "axios";

export const getTakesFeed = async (pageNumber: number, category: number) => {
  try {
    // const url = `${NEXTJS_SERVER_BASE_URL}/getTakeFeed/?pagenumber=${pageNumber}&category=${category}&pagesize=10`;
    const url = `${BASE_URL}/bro/GetTakesFeed/?pagenumber=${pageNumber}&category=${category}&pagesize=10`;
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      maxBodyLength: Infinity,
      method: "GET",
      url,
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.error(error);
  }
  return []
}
